import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { ILeadGroup } from "@/models/lead-group.entity";
import leadGroupService from "@/services/mrfiktiv/services/lead-group.service";
import { MrfiktivLeadGroupControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const LeadGroupPageDataProvider = new (class extends AbstractPageDataProvider<
  ILeadGroup,
  MrfiktivLeadGroupControllerGetParamsGen
> {
  itemsPerPage = 250;

  async getPage(query: MrfiktivLeadGroupControllerGetParamsGen): Promise<IPageViewModel<ILeadGroup>> {
    const res = await leadGroupService.get(query);

    const meta = res.meta;
    const data = (res.data ?? []) as ILeadGroup[];

    return { meta, data };
  }
})();
